import { isEmpty } from 'lodash';
import { saveCreativeError } from 'modules/campaigns/actions';
import { saveCreative as campaignsSaveCreative } from 'modules/campaigns/flows';
import { isMediaLibraryItem } from 'modules/campaigns/modules/creative-editor/components/MediaTabs/services/utils';
import { editedCreativeSelector } from 'modules/campaigns/selectors';
import { GTM_EVENTS, gtmTracker } from 'modules/taboola-common-frontend-modules/gtmTracker';
import getChangesObject from 'modules/taboola-common-frontend-modules/utils/objectDiff';
import uploadCreativeRecommendedImage from './uploadCreativeRecommendedImage';
import uploadCreativeThumbnail from './uploadCreativeThumbnail';

export const sendGTMEventForGetThumbnailUrl = (eventName, value) => {
    try {
        gtmTracker.trackEvent(eventName, {
            component: 'getThumbnailUrl usability in edit flow',
            value,
        });
    } catch (e) {}
};

const getThumbnailUrl = async (dispatch, accountId, initialCreativeChanges) => {
    const { thumbnailUrl, thumbnailFile, thumbnailRecommendedImage } = initialCreativeChanges;

    if (thumbnailFile) {
        sendGTMEventForGetThumbnailUrl(GTM_EVENTS.USABILITY, 'return thumbnailFile after upload');
        return await dispatch(uploadCreativeThumbnail(accountId, thumbnailFile));
    } else if (thumbnailRecommendedImage) {
        if (isMediaLibraryItem(thumbnailRecommendedImage)) {
            sendGTMEventForGetThumbnailUrl(GTM_EVENTS.USABILITY, 'return thumbnailRecommendedImage without upload');
            return thumbnailRecommendedImage;
        }
        sendGTMEventForGetThumbnailUrl(GTM_EVENTS.USABILITY, 'return thumbnailRecommendedImage after upload');
        return await dispatch(uploadCreativeRecommendedImage(accountId, thumbnailRecommendedImage));
    }

    return { thumbnailUrl };
};

const updateCreativeChanges = (initialCreativeChanges, thumbnailUrl) => {
    const {
        thumbnailFile: _thumbnailFile,
        thumbnailRecommendedImage: _thumbnailRecommendedImage,
        ...creativeChanges
    } = initialCreativeChanges;

    return thumbnailUrl ? { ...creativeChanges, thumbnailUrl } : creativeChanges;
};

const saveCreative =
    ({ accountId }, creative, sourcePath, navigate) =>
    async (dispatch, getState) => {
        const creativeBeingEdited = editedCreativeSelector(getState());
        const initialCreativeChanges = getChangesObject(creative, creativeBeingEdited);

        //TODO remove this in DEV-114778

        const goBack = () => (sourcePath ? navigate(sourcePath) : null);

        // If no changes, do nothing.
        if (isEmpty(initialCreativeChanges)) {
            goBack();
            return { result: creativeBeingEdited };
        }

        // Else, try to do partial update. Upload thumbnail and compute creative changes.
        const { thumbnailUrl, error: uploadError } = await getThumbnailUrl(dispatch, accountId, initialCreativeChanges);

        if (uploadError) {
            dispatch(saveCreativeError(creative.id, uploadError));
            return { error: uploadError };
        }
        const creativeChanges = updateCreativeChanges(initialCreativeChanges, thumbnailUrl);

        // Finally, update the creative.
        const { result, error: saveError } = await dispatch(
            campaignsSaveCreative(accountId, creativeBeingEdited, creativeChanges)
        );
        if (saveError) {
            throw saveError;
        }

        goBack();
        return { result };
    };

export default saveCreative;
